/*
 * @Author: pengyong
 * @Date: 2020-11-09 15:57:25
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-14 20:41:44
 * @Description:
 * @FilePath: /exhibit/src/lang/en.js
 */
export default {
    locale: 'en',
    header:{
        exhibitor: 'Exhibitors',
        info: 'Introduction',
        exhibits: 'Exhibits',
        video: 'Videos',
        home: 'Home',
        pavilion: 'Pavilion',
        exhibition: 'Exhibition',
        review: 'Review',
        search_exhibitor:'Searching for Exhibitor > "Search keywords"',
        area_selection: 'Area selection',
        place:'Place',
        start_time: 'To carry out the date',
        search_goods:'Searching Exhibit > "Search keywords" :',
        review_tip:'No review',
        choose_role: 'Please choose',
        choose_exhibition: 'Exhibitor content',
        choose_goods: 'Exhibit content',
        my: 'My',
        headertitle: 'Global digital trade cloud exhibition platform',
        is_search_exhibitor: 'Are the search',
        empty_tip: 'Search for more exciting content!',
        template_tip: 'No content so stay tuned'
    },
    exhibition: {
        pavilion: 'All of the pavilion',
        hold: 'Being held',
        ready: 'The exhibition review',
        start_time: 'Launch date',
        place: 'place',
        live: 'Meeting System',
        living_tip: 'Living',
        living: 'Japan-Aquatic pro-ducts',
        is_opening: 'Now open'
    },
    zhanqu: {
        allExh: 'All Exhibitors'
    },
    "personalCenter": {
        "exhibitorStore": 'Exhibitor Store',
        "noExhibitor": 'No Exhibitor',
        "search": 'Search',
        "exhibitsStore": 'Exhibits Store',
        'noExhibits': 'No Exhibits',
        'exhibitis': 'Exhibitis',
        'exhibitor': 'Exhibitor',
        'content': 'Confirm to logout',
        'baseInfo': 'Base Info',
        'name': 'Name',
        'gender': 'Gender',
        'male': 'Male',
        'female': 'Female',
        'country': 'Country',
        'companyName': 'Company',
        'email': 'Email',
        'nickName': 'Nickname',
        'interest': 'Interest Product',
        'save': 'Save',
        'passModify': 'Password Modify',
        'oldPassword': 'Old Password',
        'newPassword': 'New Password',
        'passwordRepeat': 'Repeat New Password',
        'passwordTip': 'Please set at least three combinations of English alphanumeric special characters with more than 8 digits'
     },
    about: {
        h2: "Basic Info",
        msg1: "Register Capital",
        msg2: "Company Scale",
        msg3: "Company Website",
        msg4: "Main Products",
        msg5: "Sale Scope"
    },
    videoList: {
        h1: "Video List",
        video: "Video"
    },
    contact: {
        msg1: "Contact Person",
        msg2: "Contact Phone",
        // msg3: "联系人邮箱",(注释掉该字段）
        msg4: "Tel",
        msg5: "Email",
        msg6: "Website",
        msg7: "Address"
    },
    conference: {
        bigconference: "conference area",
        smallconference: "roadshow area"
    },
    smallconference: {
        left: ["Agenda"],
        right: ["Introduction of Speakers", "Enterprise Introduction"]
    },
    bigconference: {
        left: ["Agenda"],
        right: ["Introduction of Speakers", "Enterprise Introduction"]
    },
    area: {
        left: ["Introduction", "Video List", "Product Description"],
        right: ["Contact Information", "Business Card", "Online Conversation"],
        searchPld: "Research",
        searchNodata: "Sorry, no results found. Please try other keywords",
        loginTip: "please login",
        noData: "No content"
    },
    card: {
        h1: "tips",
        msg:
            "Clicking to confirm means that you agree to exchange business cards with the exhibitor. Your business card information (name, phone number, etc.) will be shared with the exhibitor, so that the exhibitor can get in touch with you. Please confirm your agreement?",
        noCaution: "No more reminders",
        btn1: "Think ",
        btn2: "Agree",
        contact: 'Contact'
    },
    detail: {
        collect: "Store",
        uncollect: "Cancel",
        parameter: "Product Parameter",
        msg1: "Price：",
        msg2: "Brand Name：",
        msg3: "Product Model：",
        msg4: "Product Spec：",
        msg5: "Technical Parameters：",
        introduction: "Product Brief"
    },
    userInfo: {
        h1: "Introduction",
        zh: "Account",
        gj: "Country/ Region",
        name: "Name",
        gs: "Company",
        yxcp: "Intended Product",
        bc: "Save"
    },
    amendPassword: {
        msg1: "Old Password",
        msg2: "New Password",
        msg3: "Confirm the New Password",
        bc: "save",
        msg1Placeholder: "Please enter the old password",
        msg2Placeholder: "Please enter a new password",
        msg3Placeholder: "Please enter the new password again",
        error: "The two passwords are inconsistent",
        tip: "Please set at least three combinations of English alphanumeric special characters with more than 8 digits"
    },
    agenda: {
      title: "Agenda"
    },
    consult: {
        title: "Contact us",
        name: "Name",
        gj: "Country / region",
        yx: "Email",
        tell: "Phone",
        wenti: "My question",
        tj: "ok",
        noName: "Please type in your name",
        noCountry: "Please select the region",
        noMail: "Please input your email",
        noPhone: "Please enter phone number",
        success: "Submitted successfully"
    },
    areaIndex: {
        zxt: "Information",
        zlt: "Exhibition",
        hyt: "Conference",
        mpj: "Business Card",
        scj: "My Favorites",
        rc: "Schedule",
        home: 'Home Page'
    },
    exhibit: {
        yun: "Online Expo",
        about: "About us",
        login: "Login | Register",
        user: "Personal Center",
        exit: "Exit"
    },
    role: {
        gzTitle: "Visitor",
        gzDesc: "Log in",
        zsTitle: "Exhibitor",
        zsDesc: "Log in"
    },
    login: {
        audienceLogin: "Audience Login",
        exhibitorLogin: "Exhibitor Login",
        login: "Login",
        accountLogin: "Login by:  Password",
        phoneLogin: "Phone Number",
        emailLogin: "Email",
        accountPlaceHolder: "Please enter account",
        pswPlaceHolder: "Please enter password",
        phonePlaceholder: "Please enter phone number",
        emailPlaceholder: "Please enter your email",
        codePlaceholder: "Verification Code",
        sendCode: "Send Verification",
        autoLogin: "Remember Password",
        forget: "Forget password",
        tip: "Need an account?",
        registerTip: "Register here",
        imgPlaceHolder: "Verification Code",
        login_out: 'Logged out',
        confirm_logout: 'Are you sure to log out?',
        tip: 'Prompt',
        confirm: 'Determine',
        cancel: 'Cancel'
    },
    register: {
        register: "registered",
        phoneReg: "Mobile phone number registration",
        emailReg: "Email registration",
        countryPlaceholder: "Country / region",
        namePlaceholder: "Name (your real name)",
        companyPlaceholder: "Company name",
        productPlaceholder: "name of your Intended product",
        pswPlaceholder:
            "Please set a password of 6 to 18 digits, including at least 3 types of uppercase and lowercase English letters, numbers and special symbols",
        tip: "Already have an account？",
        loginTip: "Sign in here"
    },
    userCenter: {
        collect: "My Favorites",
        collectVideo: "Videos",
        collectZp: "Exhibits",
        collectFile: "Files",
        logout: "Logout",
        collectExhibitors: 'Exhibitors',
        card: "Business Card",
        accountInfo: "Account Information",
        baseInfo: "Basic Information",
        modifyPsw: "Change Password",
        exit: "exit",
        cardTitle: "My Business Card ",
        name: "Name",
        account: "Account",
        company: "Organization Name:",
        editCard: "Edit Business Card",
        zhiwei: "Position",
        elecCard: "Please Upload your Electronic Business Card",
        save: "save",
        inputPlaceholder: "please enter",
        video: "video",
        delet: "delet",
        play: "play",
        email: "Email:",
        address: "Address:",
        exhibition: "Exhibition:",
        edit: "Edit",
        del: "Delete",
        chooseAll: "Select all",
        chooseAllCancel: "Unselect all",
        cancel: "Cancel",
        phone: "Phone",
        post: "Post",
        save: "Save"
    },
    forget: {
        title: "选择找回密码的方式",
        byEmail: "通过注册邮箱找回密码",
        byPhone: "通过注册手机号找回密码",
        title2: "验证身份",
        phonePlaceHolder: "请输入注册时使用的手机号",
        pswPlaceHolder: "请输入新密码",
        newPswPlaceHolder: "请再次输入新密码",
        submit: "ok",
        title3: "设置完成",
        successTitle: "恭喜您修改密码成功!",
        successDesc: "10秒后自动跳转到登录界面,您也可以通过点击下方的完成按钮手动页面登录",
        complete: "完成"
    },
    chat: {
        pld: "Please enter text to start the conversation"
    },
    tips: {
        noSchedule: "Coming soon",
        noVideo: "No video",
        noProduct: "No products",
        noCollect: "Empty, hurry up to collect it！",
        noCard: "Empty, go and exchange business cards!",
        noLive: "The live broadcast did not start"
    },
    contactUsTips: {
        EDUCATION: {
          message: 'We will provide high-quality services for you to attend the Event.Please fill out the feedback form or contact us directly for more information and suggestions.\nContact Us You can also contact us directly by phone',
          workTime: 'Working Hour: Monday-Friday 8：30~17：30',
          phone: 'Tel : +86 571 87297482'
        },
        TRADE: {
          message: 'We will provide high-quality services for you to attend the Event.Please fill out the feedback form or contact us directly for more information and suggestions.\nContact Us You can also contact us directly by phone',
          workTime: 'Working Hour: Monday-Friday 8：30~17：30',
          phone: 'Tel : +86 571 87297482'
        }
    },
    myCard:{
        save_tip: 'Upload successfully, please click save',
        img_format: 'Only image format is supported',
        img_size: 'The image size should not exceed 2MB',
        save_success:'Save success'
    }
};



// WEBPACK FOOTER //
// ./src/lang/en.js